import { Injectable } from '@angular/core';
import { IAiData } from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';

import { HttpService } from '../../core/http-service/http.service';
@Injectable({
  providedIn: 'root',
})
export class AidataService {
  constructor(private readonly _httpService: HttpService) {}
  public getAiStreamText(searchedTitle: string) {
    const apiUrl = API_ENDPOINTS.AI_ENDPOINTS.aiGptStream;
    const data = {
      text: searchedTitle,
    };
    return this._httpService.post<IAiData, IAiData>(apiUrl, data);
  }
}
